import { render, staticRenderFns } from "./descriptionSet.vue?vue&type=template&id=6fb62e6f&scoped=true&"
import script from "./descriptionSet.vue?vue&type=script&lang=js&"
export * from "./descriptionSet.vue?vue&type=script&lang=js&"
import style0 from "./descriptionSet.vue?vue&type=style&index=0&id=6fb62e6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb62e6f",
  null
  
)

export default component.exports